/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Table_ModelInputs */

const en_settings_table_model = /** @type {(inputs: Settings_Table_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model`)
};

const de_settings_table_model = /** @type {(inputs: Settings_Table_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modell`)
};

const fr_settings_table_model = /** @type {(inputs: Settings_Table_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modèle`)
};

const es_settings_table_model = /** @type {(inputs: Settings_Table_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelo`)
};

const it_settings_table_model = /** @type {(inputs: Settings_Table_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modello`)
};

const nl_settings_table_model = /** @type {(inputs: Settings_Table_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model`)
};

const pl_settings_table_model = /** @type {(inputs: Settings_Table_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model`)
};

const fi_settings_table_model = /** @type {(inputs: Settings_Table_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Malli`)
};

const da_settings_table_model = /** @type {(inputs: Settings_Table_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model`)
};

const sv_settings_table_model = /** @type {(inputs: Settings_Table_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modell`)
};

/**
* | output |
* | --- |
* | "Model" |
*
* @param {Settings_Table_ModelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_table_model = /** @type {((inputs?: Settings_Table_ModelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Table_ModelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_table_model(inputs)
	if (locale === "fr") return fr_settings_table_model(inputs)
	if (locale === "es") return es_settings_table_model(inputs)
	if (locale === "it") return it_settings_table_model(inputs)
	if (locale === "nl") return nl_settings_table_model(inputs)
	if (locale === "pl") return pl_settings_table_model(inputs)
	if (locale === "fi") return fi_settings_table_model(inputs)
	if (locale === "da") return da_settings_table_model(inputs)
	if (locale === "sv") return sv_settings_table_model(inputs)
	return en_settings_table_model(inputs)
});